import { EconomicalValueChannelSourceFilters } from '@/features/broadcasters/types';
import { TableKeyEnum } from '@/hooks/useTableSettingsStore';
import { createTableFiltersState } from '@/utils/table-filters';

export const useEconomicalValueChannelSourcesFilters =
  createTableFiltersState<EconomicalValueChannelSourceFilters>({
    tableKey: TableKeyEnum.ECONOMIC_VALUE_CHANNEL_SOURCES,
  });
